import { http } from '@/utils'

const state = {
  branches: []
}

const getters = {
  uri: (state, getters, rootState) => `applications/${rootState.applications.single.id}/branches`
}

const actions = {
  async getBranches ({ commit, getters }, params) {
    const response = await http.get(getters.uri, { params })

    commit('SET_BRANCHES', response.data.data)
  },

  resetBranches ({ commit }) {
    commit('SET_BRANCHES', [])
  }
}

const mutations = {
  SET_BRANCHES (state, branches) {
    state.branches = branches
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
